import { useContext } from "react";

import { SearchOrganizationsContext } from "./SearchOrganizationsContext";

export const useSearchOrganizationsContext = () =>
  useContext(SearchOrganizationsContext);
